import type { StaticDataRouteOption } from "@tanstack/react-router"

import { AppNavigation } from "../NavigationView/AppNavigation"
import { ProjectDocumentsViewTopBar } from "./TopBar"

export const projectDocumentsViewLayoutHandle: StaticDataRouteOption = {
	leftSlideOut: AppNavigation,
	topBar: ProjectDocumentsViewTopBar,
}
